import AccessTimeIcon from '@mui/icons-material/AccessTime';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import AssessmentIcon from '@mui/icons-material/Assessment';
import AssessmentTwoToneIcon from '@mui/icons-material/AssessmentTwoTone';
import AssignmentIcon from '@mui/icons-material/Assignment';
import AssignmentInd from '@mui/icons-material/AssignmentInd';
import BugReportOutlinedIcon from '@mui/icons-material/BugReportOutlined';
import BarChartIcon from '@mui/icons-material/BarChart';
import CardTravelTwoToneIcon from '@mui/icons-material/CardTravelTwoTone';
import CodeIcon from '@mui/icons-material/Code';
import DeleteIcon from '@mui/icons-material/Delete';
import DifferenceIcon from '@mui/icons-material/Difference';
import DomainDisabledIcon from '@mui/icons-material/DomainDisabled';
import EditIcon from '@mui/icons-material/Edit';
import GroupIcon from '@mui/icons-material/Group';
import HomeIcon from '@mui/icons-material/Home';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import MoneyIcon from '@mui/icons-material/Money';
import PaymentIcon from '@mui/icons-material/Payment';
import PeopleAltOutlined from '@mui/icons-material/PeopleAltOutlined';
import PersonIcon from '@mui/icons-material/Person';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import PointOfSale from '@mui/icons-material/PointOfSale';
import PublishOutlinedIcon from '@mui/icons-material/PublishOutlined';
import RecentActorsOutlinedIcon from '@mui/icons-material/RecentActorsOutlined';
import StoreIcon from '@mui/icons-material/Store';
import TimelineIcon from '@mui/icons-material/Timeline';
import WatchLaterIcon from '@mui/icons-material/WatchLater';
import { CashInIcon, CashOutIcon, GirosSvgIcon } from '@shared/components/icons';

const MenuIcon = ({ menuItem, props = {} }) => {
  const options = {
    home: <HomeIcon {...props} />,
    subsidiaryManagement: <StoreIcon {...props} />,
    subsidiaryManagementBulk: <PublishOutlinedIcon {...props} />,
    subsidiaryScheduleManagementBulk: <AccessTimeIcon {...props} />,
    usersManagementBulk: <PublishOutlinedIcon {...props} />,
    cashin: <CashInIcon {...props} />,
    cashout: <CashOutIcon {...props} />,
    cashFlowStatement: <TimelineIcon {...props} />,
    cashierActivate: <PersonAddIcon {...props} />,
    cashierStatus: <WatchLaterIcon {...props} />,
    cashierTransactions: <TimelineIcon {...props} />,
    correspondentFeeReport: <TimelineIcon {...props} />,
    correspondentTransactionsSubsidiary: <BarChartIcon {...props} />,
    correspondentAccountBalance: <AccountBalanceIcon {...props} />,
    correspondentParameters: <CodeIcon {...props} />,
    createSubsidiary: <StoreIcon {...props} />,
    unlockUsers: <LockOpenIcon {...props} />,
    deleteSubsidiary: <DomainDisabledIcon {...props} />,
    createCorrespondentUser: <PersonAddIcon {...props} />,
    deleteCorrespondentUser: <DeleteIcon {...props} />,
    editCorrespondentUser: <EditIcon {...props} />,
    correspondentAudithReport: <TimelineIcon {...props} />,
    correspondentUser: <GroupIcon {...props} />,
    bankUser: <GroupIcon {...props} />,
    profile: <PersonIcon {...props} />,
    crpndntReport: <AssessmentTwoToneIcon {...props} />,
    crpdntManagement: <CardTravelTwoToneIcon {...props} />,
    crpdntTransactionsReport: <AssessmentIcon {...props} />,
    crpdntSubsidiaryReport: <AssessmentTwoToneIcon {...props} />,
    subsidiaryReport: <AssessmentTwoToneIcon {...props} />,
    repTransactions: <AssessmentIcon {...props} />,
    subsidiaryResponsible: <RecentActorsOutlinedIcon {...props} />,
    trnCashier: <AssessmentIcon {...props} />,
    accountBalance: <AccountBalanceIcon {...props} />,
    bankCrpdntUserReport: <AssignmentInd {...props} />,
    crpdntUserReport: <AssignmentInd {...props} />,
    userReport: <AssignmentInd {...props} />,
    correspUserReport: <AssignmentInd {...props} />,
    comisionesRecibidas: <PaymentIcon {...props} />,
    crpdntToPayBonuses: <PaymentIcon {...props} />,
    crpdntPaidBonuses: <MoneyIcon {...props} />,
    repCashRegisters: <AssignmentIcon {...props} />,
    commissionsReport: <AssessmentIcon {...props} />,
    comtecoReports: <AssessmentIcon {...props} />,
    sajubaReporte: <AssessmentIcon {...props} />,
    coopaguasReporte: <AssessmentIcon {...props} />,
    crpndntRequestManagement: <PointOfSale {...props} />,
    cashierManagement: <AssignmentIcon {...props} />,
    unlockCrspUsers: <LockOpenIcon {...props} />,
    crspUsers: <PeopleAltOutlined {...props} />,
    rolesByCrsp: <PersonIcon {...props} />,
    whiteList: <PersonIcon {...props} />,
    correspondentConciliation: <DifferenceIcon {...props} />,
    paymentComissions: <AssessmentIcon {...props} />,
    reportePagoFacil: <AssessmentIcon {...props} />,
    remittancesPayment: <GirosSvgIcon {...props} />,
    bankRoleManagement: <AdminPanelSettingsIcon {...props} />,
    clientErrors: <BugReportOutlinedIcon {...props} />,
    remittancesReport: <AssessmentIcon {...props} />,
    remittancesMonthlyReport: <AssessmentIcon {...props} />,
  };
  return options[menuItem] ?? '';
};

export default MenuIcon;
